import { useSessionStore } from '@/entities/session';
import { getInitials } from '@/shared/lib/string';
import { Avatar } from '@/shared/ui';
import { SettingTabId } from '@/widgets/setting-tabs/model/types';
import { useNavigate } from '@tanstack/react-router';
import type { FC } from 'react';

export const CurrentUserShortInfo: FC = () => {
  const navigate = useNavigate();

  const currentUser = useSessionStore((state) => state?.user);

  if (!currentUser) return null;

  const openProfile = () => {
    navigate({ to: '/settings', search: { tab: SettingTabId.Profile } });
  };

  return (
    <div
      role="button"
      className="flex cursor-pointer items-center"
      tabIndex={0}
      title={currentUser.fullName}
      aria-label={currentUser.fullName}
      onClick={openProfile}
      // The div is focusable, so it has to answer Enter/Space like a real button.
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openProfile();
        }
      }}
    >
      <Avatar
        size="small"
        src={currentUser.profileUrl}
        initials={getInitials(currentUser.fullName)}
      />
    </div>
  );
};
